import { Col, Input, Label } from "reactstrap";
import { Custom } from "../../../../Constant";
import { H6, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const CustomImagesWithCheckbox = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{Custom}</H6>
        <div className="img-checkbox">
          <Input className="main-img-cover form-check-input" id="img-check-1" type="checkbox" />
          <Label className="form-check-label mb-0" htmlFor="img-check-1">
            <Image src={dynamicImage("switch/1.jpg")} alt="coffee-beans" />
          </Label>
        </div>
      </div>
    </Col>
  );
};
